import { gql } from '@apollo/client';
import { MeasureFragment } from './fragments';
import { ErrorFragment } from '../fragments';

export const CREATE_NAMED_MEASURE = gql`
  mutation NamedMeasureCreate($input: NamedMeasureCreateInput!) {
    namedMeasureCreate(input: $input) {
      entity {
        ...MeasureFields
      }
      errors {
        ...ErrorFields
      }
    }
  }
  ${MeasureFragment}
  ${ErrorFragment}
`;

export const EDIT_NAMED_MEASURE = gql`
  mutation NamedMeasureEdit($input: NamedMeasureEditInput!) {
    namedMeasureEdit(input: $input) {
      entity {
        ...MeasureFields
      }
      errors {
        ...ErrorFields
      }
    }
  }
  ${MeasureFragment}
  ${ErrorFragment}
`;

export const DELETE_NAMED_MEASURE = gql`
  mutation NamedMeasureDelete($input: NamedMeasureDeleteInput!) {
    namedMeasureDelete(input: $input) {
      errors {
        ...ErrorFields
      }
      message
    }
  }
  ${ErrorFragment}
`;

export const NAMED_MEASURE_ADD_CATEGORY = gql`
  mutation NamedMeasureAddCategory($input: NamedEntityEditCategoryInput!) {
    namedMeasureAddCategory(input: $input) {
      message
      errors {
        ...ErrorFields
      }
    }
  }
  ${ErrorFragment}
`;

export const NAMED_MEASURE_REMOVE_CATEGORY = gql`
  mutation NamedMeasureRemoveCategory($input: NamedEntityEditCategoryInput!) {
    namedMeasureRemoveCategory(input: $input) {
      message
      errors {
        ...ErrorFields
      }
    }
  }
  ${ErrorFragment}
`;
